module.exports = {
      id: "share-pintrest-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#share-pintrest",
      toString: function () {
        return this.url;
      }
    }